(() => {
  if (window.__bbbAiCardBadgeInitV3) return;
  window.__bbbAiCardBadgeInitV3 = true;

  const normalizeImageUrl = (value) => {
    if (!value) return '';

    const cleanFilename = (raw) => {
      let filename = raw.split('/').pop() || raw;
      filename = filename.toLowerCase();
      filename = filename.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|master|\d+x\d+)(?=\.[a-z0-9]+$)/i, '');
      return filename;
    };

    try {
      const url = new URL(value, window.location.origin);
      const path = decodeURIComponent(url.pathname);
      return cleanFilename(path);
    } catch (_) {
      let raw = String(value).split(/[?#]/)[0];
      try { raw = decodeURIComponent(raw); } catch (_) {}
      return cleanFilename(raw);
    }
  };

  const getAiImageKeys = (badge) => (badge.dataset.aiImageUrls || '').split('|').map(normalizeImageUrl).filter(Boolean);

  const getActiveSlide = (gallery) => {
    const slides = Array.from(gallery.querySelectorAll('slideshow-slide')).filter((slide) => !slide.hidden);
    if (!slides.length) return null;
    const explicitlyActive = slides.find((slide) => slide.getAttribute('aria-hidden') === 'false');
    if (explicitlyActive) return explicitlyActive;
    const galleryRect = gallery.getBoundingClientRect();
    let bestSlide = slides[0];
    let bestArea = -1;
    slides.forEach((slide) => {
      const rect = slide.getBoundingClientRect();
      const width = Math.max(0, Math.min(rect.right, galleryRect.right) - Math.max(rect.left, galleryRect.left));
      const height = Math.max(0, Math.min(rect.bottom, galleryRect.bottom) - Math.max(rect.top, galleryRect.top));
      const area = width * height;
      if (area > bestArea) { bestArea = area; bestSlide = slide; }
    });
    return bestSlide;
  };

  const updateBadge = (gallery) => {
    const badge = gallery.querySelector(':scope > .product-card__ai-badge');
    if (!badge) return;
    const aiKeys = getAiImageKeys(badge);
    const activeSlide = getActiveSlide(gallery);
    const image = activeSlide?.querySelector('img');
    const imageKey = normalizeImageUrl(image?.currentSrc || image?.src);
    badge.hidden = !(imageKey && aiKeys.includes(imageKey));
  };

  const scheduleUpdate = (gallery) => {
    if (!gallery) return;
    [0, 80, 220, 450].forEach((delay) => window.setTimeout(() => updateBadge(gallery), delay));
  };

  const initializeGallery = (gallery) => {
    if (!(gallery instanceof HTMLElement)) return;
    if (!gallery.querySelector(':scope > .product-card__ai-badge')) return;
    updateBadge(gallery);
    if (gallery.dataset.aiBadgeInitializedV2 === 'true') return;
    gallery.dataset.aiBadgeInitializedV2 = 'true';
    const observer = new MutationObserver(() => scheduleUpdate(gallery));
    observer.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['aria-hidden','hidden','class','style','src','srcset'] });
    gallery.addEventListener('transitionend', () => scheduleUpdate(gallery));
  };

  const initializeAboutAiBadge = (root = document) => {
    const images = root.querySelectorAll?.('img') || [];
    images.forEach((img) => {
      const key = normalizeImageUrl(img.currentSrc || img.src);
      if (!key.includes('f0ca9')) return;
      const section = img.closest('.section');
      if (!section || section.querySelector(':scope > .about-ai-badge')) return;
      section.style.position = 'relative';
      const badge = document.createElement('span');
      badge.className = 'about-ai-badge';
      badge.textContent = 'KI-generiertes Bild';
      badge.style.cssText = 'position:absolute;right:16px;bottom:16px;z-index:20;pointer-events:none;background:transparent;color:rgba(255,255,255,.72);padding:0;border:0;border-radius:0;font-size:10px;font-weight:400;line-height:1.2;';
      section.appendChild(badge);
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll?.('.card-gallery').forEach(initializeGallery);
    initializeAboutAiBadge(root);
  };

  const handleInteraction = (event) => {
    const gallery = event.target instanceof Element ? event.target.closest('.card-gallery') : null;
    if (gallery) scheduleUpdate(gallery);
  };

  document.addEventListener('click', handleInteraction, true);
  document.addEventListener('pointerup', handleInteraction, true);
  document.addEventListener('touchend', handleInteraction, true);
  document.addEventListener('keydown', handleInteraction, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  else initializeAll();

  const pageObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('.card-gallery')) initializeGallery(node);
        initializeAll(node);
      });
    }
  });

  pageObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', () => initializeAll());
})();
